import FactLoader from './FactLoader';

/** @deprecated Prefer `<FactLoader show={loading} />` directly. Kept for existing call sites. */
const LoadingSpinner = () => <FactLoader show={true} />;

export default LoadingSpinner;
